import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    clienteId: 0,
    cliente: null,
    clienteNombre: null,
    inactivo: false,
    rowVersion: null,
    
    marcaDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_MARCA'(state, marcaId) {
        state.id = marcaId;
        state.nombre = '';
        state.clienteId = 0;
        state.cliente = null;
        state.clienteNombre = null;
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_MARCA'(state, marca) {
        state.nombre = marca.nombre.toUpperCase().trim();
        state.clienteId = marca.cliente? marca.cliente.id : 0;
        state.cliente = marca.cliente;
        state.clienteNombre = marca.cliente? marca.cliente.nombre : null;
        state.inactivo = marca.inactivo;
        state.rowVersion = marca.rowVersion;
    },
    'SET_CLIENTE'(state, cliente) {
        state.cliente = cliente;

        if (cliente) {
            state.clienteId = cliente.id? cliente.id : 0;
            state.clienteNombre = cliente.nombre? cliente.nombre.trim() : null;
        } else {
            state.clienteId = 0;
            state.clienteNombre = null;
        }
    },
    'INICIALIZAR_MARCA_CLIENTE'(state, params) {
        state.id = params.marcaId;
        state.nombre = '';
        state.clienteId = params.clienteId;
        state.cliente = null;
        state.clienteNombre = null;
        state.inactivo = false;
        state.rowVersion = params.rowVersion;
    },
    'SET_MARCA_CLIENTE'(state, marca) {
        state.nombre = marca.nombre.toUpperCase().trim();
        state.inactivo = marca.inactivo;
    },

    'SET_MARCA_ID' (state, params) {
        state.id = params.id;
        state.rowVersion = params.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.marcaDatos = [];
    },
    'SET_DATOS'(state, datos) {
        state.marcaDatos = datos;
    },
};

const getters = {
    getField,

    marcaId (state) {
        return state.marcaId;
    },
    marca(state) {
        return {
            id: state.id,
            nombre: state.nombre.toUpperCase().trim(),
            inactivo: state.inactivo,
            rowVersion: state.rowVersion
        }
    }
};

const actions = {
    inicializar ( { commit }, marcaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_MARCA', marcaId);

            if (marcaId != 0) {
                apiAxios.get(`marcas/${marcaId}/abm` ) 
                    .then(res => {
                        commit('SET_MARCA', res.data);
                        resolve();
                    })
                    .catch(error => reject(error))
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },    
    inicializarMarcaCliente ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_MARCA_CLIENTE', params);

            if (params.marcaId != 0) {
                apiAxios.get(`marcas/${params.marcaId}/abm` ) 
                    .then(res => {
                        commit('SET_MARCA_CLIENTE', res.data);
                        resolve();
                    })
                    .catch(error => reject(error))
            } else {
                resolve();
            }

        }, error => {
            reject(error);
        })
    },    
    save ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            let marca = {
                nombre: state.nombre.toUpperCase().trim(),
                clienteId: state.clienteId,
                inactivo: state.inactivo,
            }

            let url = 'marcas';
            if (state.id != 0) {
                url += '/' + state.id;
                marca.rowVersion = state.rowVersion;
            }
            
            apiAxios.post(url, marca)
                .then(res => {
                    commit('SET_MARCA_ID', res.data);
                    resolve()
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setCliente: ({commit}, cliente) => {
        commit('SET_CLIENTE', cliente);
    },

    getDatos ( { commit }, marcaId ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_DATOS');
            
            if (marcaId) {
                if (marcaId != 0) {
                    apiAxios.get(`marcas/${marcaId}`) 
                    .then(res => {
                        var datos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': res.data.cliente, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                        ];
                        commit('SET_DATOS', datos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
                }
            } 
        }, error => {
            reject(error);
        })            
    },
    inactivar ( {}, marcaId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`marcas/${marcaId}/inactivar`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}